import React, { createContext, useState, useEffect } from 'react'

import { isMobile } from 'react-device-detect'
import useWindowSize from 'core/hooks/use-window-size'

const GlobalContext = createContext()

const GlobalProvider = (props) => {
  const checkMobile = (width) => {
    return isMobile || width <= 600
  }

  const [mobile, setMobile] = useState(checkMobile(window.innerWidth))
  const [background, setBackground] = useState(null)
  const [width, height] = useWindowSize()

  useEffect(() => {
    setMobile(checkMobile(width))
  }, [width])

  return (
    <GlobalContext.Provider
      value={{ background, setBackground, mobile, screenWidth: width, screenHeight: height }}
      {...props}
    >
      {props.children}
    </GlobalContext.Provider>
  )
}

export { GlobalProvider, GlobalContext }

export default GlobalContext
